import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import edit from "../../Assets/svg/edit.svg";
import dt from "../../Assets/svg/delete.svg";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import uploadIcon from "../../Assets/svg/upload-icon.svg";
import downloadIcon from "../../Assets/svg/download-icon.svg";
import { getCookie } from "../getcookie.js";
import { useGlobal } from "../../GlobalContext.js";
import { apiCall } from "../../services/api-service.js";
import ListFooter from "../common/ListFooter.jsx";
import ReportButton from "../common/ReportButton.jsx";

import "./vendor.css";
import { deleteApi, getApi } from "../common/api-client.js";
import DeleteModal from "../common/DeleteModal";
import { useExcelActions } from "../../hooks/useExcelActions";

const Vendorlist = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const { rolePermissionList } = useGlobal();
  const fileInputRef = useRef(null);


  const [vendorList, setVendorList] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const getListData = async () => {
    try {
      const data = await getApi(`${apiUrl}vendor`, {
        limit: itemsPerPage,
        skip: itemOffset,
        app_id: 28,
        search: term,
      });

      if (data.success) {
        const totalPages = data.total_pgs ?? 0;
        setTotalCount(data.total_rec ?? 0);
        setPageCount(totalPages);
        setVendorList(data.vendors);

        // Snap back to the last page if the current page is now out of range.
        const currentPage = Math.floor(itemOffset / itemsPerPage);
        if (currentPage > totalPages) {
          setItemOffset(totalPages * itemsPerPage);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const {
    uploadLoading,
    templateLoading,
    reportLoading,
    handleFileUpload,
    downloadTemplate,
    downloadReport,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
    isDragging,
  } = useExcelActions(
    "vendor",
    getListData,
    {
      setSnackbarMessage,
      setSnackbarStatus,
      handleSnackbarShow,
    },
    "vendors"
  );


  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [term, setTerm] = useState("");


  const handleChange = (e) => {
    setItemOffset(0);
    setTerm(e.target.value);
  };

  const handlePageClick = useCallback(
    (event) => {
      setItemOffset(event.selected * itemsPerPage);
    },
    [itemsPerPage]
  );

  function checkPermission(menuName, permission) {
    return (
      rolePermissionList.findIndex(
        (el) =>
          el.name === menuName &&
          el.menu_permission === true &&
          el[permission] === true
      ) > -1
    );
  }

  const deleteTeam = (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };

  const handleDeleteApi = async () => {
    if (!deleteId) return;

    try {
      const data = await deleteApi(`${apiUrl}vendor/${deleteId}`);

      setSnackbarMessage(data.message);
      setSnackbarStatus(data.success);
      handleSnackbarShow();

      if (data.success) {
        setDeleteId(null);
        setIsOpenDelete(false);
        getListData();
      }
    } catch (error) {
      setSnackbarMessage(error.response?.data?.message || "Something went wrong");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };


  useEffect(() => {
    getListData();
  }, [itemOffset, itemsPerPage, term]);

  return (
    <Container fluid className="vendor-container">
      <div className="d-flex side4">
        <Row sm={12} className="vendor-row">
          <Col>
            <div className="maincontent3 vendor-main">
              {/* Header */}
              <div className="vendor-header">
                <div>
                  <span className="vendor-title">Vendor</span>
                  <div className="vendor-subtitle">
                    Manage your vendors and create new vendors here
                  </div>
                </div>

                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <div
                    onClick={() => !uploadLoading && fileInputRef.current.click()}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{
                      height: "40px",
                      borderRadius: "100px",
                      padding: "8px 16px",
                      gap: "8px",
                      backgroundColor: isDragging ? "#F0E9FF" : "#FFFFFF",
                      border: isDragging ? "2px dashed #6929E2" : "1px solid #E5E5E5",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: uploadLoading ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileUpload}
                      accept=".xlsx, .xls"
                      style={{ display: "none" }}
                    />
                    {uploadLoading ? (
                      <div className="spinner"></div>
                    ) : (
                      <img
                        src={uploadIcon}
                        alt="excel"
                        style={{ width: "16px", height: "16px" }}
                      />
                    )}
                    <p
                      style={{
                        margin: "0",
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "14px",
                        lineHeight: "18.9px",
                        color: "#212129",
                      }}
                    >
                      Upload
                    </p>
                  </div>
                  
                  <div
                    onClick={downloadTemplate}
                    style={{
                      height: "40px",
                      borderRadius: "100px",
                      padding: "8px 16px",
                      gap: "8px",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #E5E5E5",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    {templateLoading ? (
                      <div className="spinner"></div>
                    ) : (
                      <img
                        src={downloadIcon}
                        alt="template"
                        style={{ width: "16px", height: "16px" }}
                      />
                    )}
                    <p
                      style={{
                        margin: "0",
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "14px",
                        lineHeight: "18.9px",
                        color: "#212129",
                      }}
                    >
                      Template
                    </p>
                  </div>
                  {checkPermission("Vendor", "create_permission") && (
                    <Link to="/vendor/add" style={{ textDecoration: "none" }}>
                      <div className="add-vendor-btn">
                        <p className="add-vendor-text">+ Add vendor</p>
                      </div>
                    </Link>
                  )}
                </div>
              </div>

              {/* Top Controls */}
              <div className="vendor-topbar">
                <p className="total-vendors">Total vendors: {totalCount}</p>

<div
                  style={{
                    height: "40px",
                    gap: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "16px",
                  }}
                >
                <div className="vendor-controls">
                  <input
                    type="search"
                    value={term}
                    onChange={handleChange}
                    placeholder="Search vendor"
                    className="search-input"
                  />

                </div>
                <ReportButton
                    loading={reportLoading}
                    onClick={() => downloadReport({ search: term })}
                  />
                  </div>
              </div>

              {/* Table */}
              <div className="vendor-table">
                <div style={{ overflowX: "auto" }}>
                  <div className="vendor-table-header" style={{ minWidth: "900px" }}>
                    <span className="vendor-header-text" style={{ flex: 2 }}>
                      Code
                    </span>
                    <span className="vendor-header-text" style={{ flex: 2 }}>
                      Vendor name
                    </span>
                    <span className="vendor-header-text" style={{ flex: 4 }}>
                      Project
                    </span>
                    <span className="vendor-header-text" style={{ flex: 2 }}>
                      Email
                    </span>
                    <span className="vendor-header-text" style={{ flex: 3 }}>
                      Mobile number
                    </span>
                    <span style={{ flex: 1 }}></span>
                  </div>

                  {vendorList.map((item, index) => (
                    <div key={index} className="vendor-row-item" style={{ minWidth: "900px" }}>
                      <span className="vendor-cell" style={{ flex: 2 }}>
                        #{item.code}
                      </span>
                      <span className="vendor-cell" style={{ flex: 2 }}>
                        {item.name}
                      </span>
                      <span
                        className="vendor-cell"
                        style={{ flex: 4 }}
                        title={item.projects}
                      >
                        {item.projects}
                      </span>
                      <span className="vendor-cell" style={{ flex: 2 }}>
                        {item.email}
                      </span>
                      <span className="vendor-cell" style={{ flex: 3 }}>
                        {item.phonenumber}
                      </span>

                      <div className="d-flex" style={{ flex: 1, gap: "20px" }}>
                        {checkPermission("Vendor", "edit_permission") && (
                          <div
                            className="action-btn"
                            onClick={() =>
                              navigate("/vendor/add", {
                                state: { id: item.id },
                              })
                            }
                          >
                            <img src={edit} alt="edit" />
                          </div>
                        )}

                        {checkPermission("Vendor", "delete_permission") && (
                          <div
                            className="action-btn"
                            onClick={() => deleteTeam(item.id)}
                          >
                            <img src={dt} alt="delete" />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <ListFooter
                  itemsPerPage={itemsPerPage}
                  onItemsPerPageChange={(n) => {
                    setItemsPerPage(n);
                    setItemOffset(0);
                  }}
                  pagination={
                    <ReactPaginate
                      previousLabel={<img src={lar} className="ar3" alt="prev" />}
                      nextLabel={<img src={rar} className="ar3" alt="next" />}
                      pageCount={pageCount + 1}
                      forcePage={Math.min(
                        Math.floor(itemOffset / itemsPerPage),
                        pageCount
                      )}
                      onPageChange={handlePageClick}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <DeleteModal
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={handleDeleteApi}
        title="Delete Vendor"
        message="You won’t able to access your project after deleting. Are you sure want to delete?"
      />

      {/* Toast */}
      <ToastContainer
        className="p-3"
        position="top-end"
        style={{ zIndex: 9999, position: "fixed", top: "20px", right: "20px" }}
      >
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default Vendorlist;
